<div class="" role="main">
    <div class="">
      <div class="">
        <div class="dnb-global-footer dnb-global-footer-product">
          <div class="product-name">
            <img alt="D&B Full Logo image" 
              src="https://productdesign.dnb.com/wp-content/themes/dnb-product-style-guide/library/dnb-product-design-guide/img/dnb_full_logo.png">
          </div>
          <div class="company-info">
            <ul class="legal">
              <li class="copyright">© Dun &amp; Bradstreet, Inc. 2021. All Rights Reserved.</li>
              <li><a aria-label="Link to Privacy Policy" href="http://www.dnb.com/privacy-policy.html">Privacy Policy</a></li>
			  <li><a aria-label="Disclaimer" [routerLink]="'/unlocked/disclaimer-home'">China Data Disclaimer</a></li>
            </ul>
          </div>  
          <div id="consent-banner"></div><div id="teconsent"></div>
        </div>
      </div>
    </div>
  </div>
  
